import Axios from "axios";
import { SET_CURRENT_USER, GET_ERRORS } from "./types";
import jwt_decode from "jwt-decode";
import HistoryRedirect from "../../helpers/HistoryRedirect";
import { valueMultiOrdersFilter } from "./filtersAction";
import { setUserContext } from "../../utils/sentry";
import * as Sentry from '@sentry/react';

const error = () => {
  if (!document.getElementById("loginError")) return;
  document.getElementById("loginError").style.display = "block";
  setTimeout(
    () => (document.getElementById("loginError").style.display = "none"),
    5000
  );
};

export const loginUser = (userData, history) => (dispatch) => {
  Axios.post("/login.json", userData)
    .then((res) => {
      localStorage.setItem("trToken", res.headers.authorization);
      const data = res.data;
      const decoded = jwt_decode(res.headers.authorization);
      const user_data = { ...decoded, ...data };
      dispatch(setCurrentUser(user_data));

      HistoryRedirect(user_data.user_role.permissions, history);
    })
    .catch((err) => {
      error();
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const userAdditionalInformation =
  (user_id) => async (dispatch, getState) => {
    try {
      const reduxData = getState().auth.user;
      if (user_id) {
        if (reduxData.id !== user_id) return;
      }

      const { data } = await Axios.get("/api/v1/users/additional_information");
      dispatch({
        type: "SET_ADDITIONAL_INFO",
        payload: data,
      });
    } catch (err) {
      console.log("ERROR:", err);
    }
  };

export const setCurrentUser = (decoded) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_USER,
    payload: decoded,
  });
  
  if (decoded && decoded.id) {
    setUserContext({
      id: decoded.id,
      email: decoded.email,
      username: decoded.name || decoded.username,
    });
  }
  
  if (
    decoded?.user_statuses ||
    decoded?.user_categories ||
    decoded?.user_suppliers
  ) {
    dispatch(
      valueMultiOrdersFilter({
        statusFilter: decoded?.user_statuses || [],
        categoryFilter: decoded?.user_categories || [],
        user_suppliers: decoded?.user_suppliers || [],
      })
    );
  }
};

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("trToken");
  
  Sentry.setUser(null);
  
  dispatch(setCurrentUser({}));
  Axios.delete("/logout.json").then((response) => {
    window.location.href = "/sign_in";
  });
};
